<p-splitter
  class="tf-ai-assistant-shell-splitter"
  [class.is-rob-closed]="!panelService.isPanelVisible()"
  layout="horizontal"
  [gutterSize]="splitterGutterSize"
  [panelSizes]="splitterPanelSizes"
  [minSizes]="splitterMinSizes"
  stateStorage="local"
  [stateKey]="splitterStateKey">
  <ng-template #panel>
    <div class="tf-ai-assistant-shell-main" data-app-main>
      <ng-container [ngTemplateOutlet]="content()" />
    </div>
  </ng-template>
  <ng-template #panel>
    @if (panelService.isPanelVisible()) {
      <tf-ai-assistant
        #assistantPanel
        data-testid="cmp-ai-assistant-panel"
        (closed)="panelService.close()" />
    }
  </ng-template>
</p-splitter>
